<template>
  <div class="version">
    <!-- :disabled="disableDropdown" -->
    <div class="version-content">
      <el-dropdown
        trigger="click"
        @command="versionCommand"
      >
        <el-button class="version-btn" :style="{backgroundColor: backgroundColor}">
          {{ curVersion
          }}<i
            class="el-icon-arrow-down el-icon--right"
          ></i>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu class="project-dropdown">
            <el-dropdown-item
              v-for="(v, index) in list"
              class="dropdown-item"
              :command="index"
              :key="index"
              >{{ v?.title }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>
<script>

export default {
  name: "version",
  props: {
    itemModel: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    versionIndex: {
      type: Number,
      default: 0,
    },
    version: {
      type: String,
      default: ""
    }
  },
  watch: {
    itemModel(val) {
      this.curModel = val;
    },
  },
  data() {
    return {
      curIndex: null,
    };
  },
  methods: {

    versionCommand(index) {
      console.log("index = ", index)
      this.curIndex = index;
      const item = this.list[this.curIndex]
      this.$emit("selectIrqDo", {item: item, versionIndex: this.versionIndex})
    },
  },
  computed: {

    curVersion() {
      let version = ""
      if (!this.curIndex) {
        version = this.version ? this.version : this.list[0]?.title 
      } else {
        version = this.list[this.curIndex]?.title
      }
      return version ? version : this.list[0]?.title 
    },

  },
  created() {

  },
};
</script>
<style lang='less' scoped>
.version-content {
  height: 100%;
  .version-btn {
    // background-color: #f6f6f6;
    font-size: 16px;
    align-items: center;
    border: 1px solid #ededed;
    border-radius: 4px;
    min-width: 100px !important;
    width: calc((100vw - 720px) / 4);//200px;
    max-width: 200px;
    padding-left: 15px;
    height: 46px;
    display: flex;
    flex-direction: row;
    color: #565656;
    justify-content: space-between;
    i {
      position: absolute;
      right: 20px;
    }
  }
}

.project-dropdown {
  height: 200px;
  overflow: auto;
}

// calc(100% - 256px);
.el-dropdown-menu__item {
  color: #565656 !important;
  min-width: 100px !important;
  width: calc((100vw - 720px) / 4) !important; //calc((100vw - 720px) / 4)
  max-width: 200px !important;
}
</style>